<template>
    <div class="layout">
        <LeftNav />
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
import LeftNav from "./LeftNav";
export default {
    name: "index",
    components: {
        LeftNav,
    }
}
</script>

<style scoped>
div.layout{
    height: 100%;
    display: flex;
}
</style>